export default __webpack_public_path__ + "static/media/4N.99979ab1.jpg";